// AreasOfWorkSection.jsx

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import { CategoryGet } from '../../api/orgService';
import useApi from '../../api/useApi';
import { toast } from 'react-toastify';
// import { CategoryGet } from '@/src/api/orgService';


const areasData = [
  {
    name: "Health",
    description:
      "The number of complex and protracted emergencies is increasing. As a result, more people than ever are vulnerable and need humanitarian support.",
    image_introduction: "https://picsum.photos/200/100?random=1",
    link: "/what-we-do/health",
    category_alias:"health"
  },
  {
    name: "Humanitarian Response",
    description:
      "Women, who pay the highest price of unjust policies and patriarchal societies, must play a key role in order to bring about social change.",
    image_introduction: "https://picsum.photos/200/100?random=2",
    link: "/what-we-do/womens-rights",
    category_alias:"humanitarian-response"
  },
  {
    name: "Alcohol & Substance Abuse",
    description:
      "The climate crisis is destroying lives and livelihoods across the world. People living in poverty – especially women – are most affected.",
    image_introduction: "https://picsum.photos/200/100?random=3",
    link: "/what-we-do/land-and-climate",
    category_alias:"drug-substance-abuse"
  },
  {
    name: "Women Maternal Health",
    description:
      "Representative and inclusive democracies are vital, but civic space is shrinking and regressive taxation is keeping people in poverty.",
    image_introduction: "https://picsum.photos/200/100?random=4",
    link: "/what-we-do/health",
    category_alias:"health"
  },
];

const AreasOfWorkSection = ({singleView=[],all=false}) => {

  const navigate = useNavigate()
  const location = useLocation()
  const [areas,setAreas] = useState(areasData||[])

  // get area of work categories

  const { request: getAllCategories, data:categoryData, error:categoryError} = useApi(CategoryGet);
    
    useEffect(() => {
      getAllCategories();
           // eslint-disable-next-line
      }, []);
      
      useEffect(()=>{
        if (categoryData?.status===200) {
          setAreas(categoryData?.data?.results);
        }
      // eslint-disable-next-line
      },[categoryData,singleView])
  
      useEffect(()=>{
          if(location?.state?.refresh==="category"){
            getAllCategories();
          }
        // eslint-disable-next-line
      },[location?.state])
    
    //   useEffect(()=>{
    //     if(location?.state?.previewCategory){
    //       // getAllCategories();
    //       setAreas((prev)=>[...prev, location?.state?.previewCategory]);
    //     }
    //   // eslint-disable-next-line
    // },[location?.state?.previewCategory,categoryData])
      useEffect(()=>{
          if(categoryError){
              toast.error(`${JSON.stringify(categoryError?.response?.data,null,2)}`,{position: "top-center"});
        }
      },[categoryError])
  // End get area of work categories


  useEffect(()=>{
    if(singleView?.length>0){
      console.log(singleView)
      if(all===true){
        setAreas((prev)=>[...prev,singleView[0]])
      }else{
      setAreas(singleView)
      }
    }
  },[singleView,location,categoryData])

  return (
    <section className="areas-section">
      <h2 className="section-title">Areas of work</h2>
      <div className="areas-grid">
        {areas.length>0 && areas?.map((area, index) => (
          <div 
          key={index} 
          className="area-card"
          onClick={()=>{
            console.log(area)
            navigate(`/what-we-do/${area?.category_alias}`,{state:{category_alias:area?.category_alias,id:area?.id}})
            // handleClose
            }}
          >
            <div className="area-image" style={{ backgroundImage: `url(${area?.image_introduction})` }} />
            <div className="area-content">
              <h3 className="area-title">{area.name}</h3>
              <p className="area-description">{area?.description.slice(0, 150)}</p>
              {/* <a className="area-link" href={area.link}>
                Learn more →
              </a> */}
              <Link className="area-link" to={area?.link} state={{category_alias:area?.category_alias}}>
                Learn more →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AreasOfWorkSection;
